import { ProductDefinition } from "../types/proposal";

export const PRODUCTS: ProductDefinition[] = [
  {
    id: "multiscent20",
    name: "MultiScent20",
    description: "Equipamento de avaliação olfativa",
    unitPrice: 5550,
  },
  {
    id: "multiscent20-screen",
    name: "MultiScent20 Screen",
    description: "Equipamento de avaliação olfativa com tela",
    unitPrice: 9550,
  },
  {
    id: "capsule-kit",
    name: "Kit de Cápsulas",
    description: "Kit de cápsulas para o MultiScent20",
    unitPrice: 590,
  },
  {
    id: "web-platform",
    name: "Plataforma Web",
    description: "Acesso à plataforma de gestão Noar Health",
    unitPrice: 98,
  },
];

export const DEFAULT_ORIGIN_ZIP_CODE = "09810-010";
